import { FC, useContext } from "react";
import Link from "next/link";
import { AuthorNameWrapper } from "./Author.styled";
import { useDevice } from "common/hooks/useDevice";
import { articleTypes } from "../../Context/ArticleContext";
import { ArticleContext } from "../../Context";

const AuthorName = () => {
  const { refactoredArticle } = useContext<articleTypes>(ArticleContext);
  const { authors } = refactoredArticle;

  const { screenSize } = useDevice();
  if (!authors) {
    return null;
  }
  const { path, name, jobTitle } = authors[0];

  return (
    <AuthorNameWrapper>
      <div className="name_wrapper">
        <span>By&nbsp;</span>
        <Link href={path ? path : "/"}>{name}</Link> &nbsp;
        {jobTitle && <> | &nbsp; {jobTitle} &nbsp; |</>}
      </div>
    </AuthorNameWrapper>
  );
};

export default AuthorName;
